export default __webpack_public_path__ + "static/media/559.240cd215.png";